(() => {
  if (customElements.get('moshulu-plp-review-nuggets')) return;

  let activeReviews = null;

  const popupStyle = document.createElement('style');

  popupStyle.textContent = `
    .plp-test-reviews-dialog::backdrop {
      background: transparent;
    }
  `;

  document.head.append(popupStyle);

  function openReviewLayer(owner) {
    const quickView = owner.closest('dialog');
    const popup = document.getElementById('reviews_fade');

    if (
      !quickView?.open ||
      !popup ||
      popup.style.display === 'none' ||
      activeReviews
    ) {
      return;
    }

    const trigger = owner.querySelector('.ruk_rating_snippet');
    const placeholder = document.createComment('Reviews popup position');

    popup.before(placeholder);

    const layer = document.createElement('dialog');

    layer.className = 'plp-test-reviews-dialog';
    layer.setAttribute('aria-label', 'Product reviews');

    layer.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;max-width:none;' +
      'max-height:none;margin:0;padding:0;border:0;background:transparent;' +
      'overflow:auto;';

    layer.append(popup);
    document.body.append(layer);

    const closeButton = popup.querySelector('#reviews_container-close');

    const oldTabIndex = closeButton?.getAttribute('tabindex');
    const oldRole = closeButton?.getAttribute('role');
    const oldLabel = closeButton?.getAttribute('aria-label');

    let finished = false;

    const restoreAttribute = (name, value) => {
      if (!closeButton) return;

      if (value === null) {
        closeButton.removeAttribute(name);
      } else {
        closeButton.setAttribute(name, value);
      }
    };

    const finish = () => {
      if (finished) return;

      finished = true;

      observer.disconnect();
      quickView.removeEventListener('close', finish);

      closeButton?.removeEventListener(
        'keydown',
        closeWithKeyboard
      );

      popup.style.display = 'none';

      document.body.classList.remove('reviews-popup');
      document.documentElement.classList.remove('reviews-popup');

      restoreAttribute('tabindex', oldTabIndex);
      restoreAttribute('role', oldRole);
      restoreAttribute('aria-label', oldLabel);

      placeholder.replaceWith(popup);

      if (layer.open) {
        layer.close();
      }

      layer.remove();
      activeReviews = null;

      if (quickView.open && trigger?.isConnected) {
        trigger.focus({ preventScroll: true });
      }
    };

    const closeWithKeyboard = event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        finish();
      }
    };

    const observer = new MutationObserver(() => {
      if (popup.style.display === 'none') {
        finish();
      }
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['style']
    });

    layer.addEventListener('cancel', event => {
      event.preventDefault();
      finish();
    });

    layer.addEventListener('close', finish);
    quickView.addEventListener('close', finish);

    closeButton?.setAttribute('tabindex', '0');
    closeButton?.setAttribute('role', 'button');
    closeButton?.setAttribute('aria-label', 'Close product reviews');

    closeButton?.addEventListener(
      'keydown',
      closeWithKeyboard
    );

    activeReviews = { owner, finish };

    layer.showModal();
    closeButton?.focus({ preventScroll: true });
  }

  class ReviewStars extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();

      let attempts = 0;

      this.onClick = () => openReviewLayer(this);

      this.onKeyDown = event => {
        if (
          (event.key === 'Enter' || event.key === ' ') &&
          event.target.matches('.ruk_rating_snippet[role="button"]')
        ) {
          event.preventDefault();
          event.target.click();
        }
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);

      const initialise = () => {
        if (!this.isConnected) return;

        const snippet = this.querySelector('.ruk_rating_snippet');

        // Wait for the actual reviews library, not just its theme wrapper.
        if (
          snippet &&
          typeof window.ratingSnippet === 'function'
        ) {
          try {
            window.ratingSnippet('ruk_rating_snippet', {
              store: 'www-moshulu-co-uk',
              color: '#FFC800',
              linebreak: false,
              text: '',
              singularText: '',
              usePolaris: true,
              ...window.REVIEWS_IO_CONFIG
            });

            return;
          } catch (error) {
            // Retry while the reviews library finishes loading.
          }
        }

        if (++attempts < 40) {
          this.retry = window.setTimeout(initialise, 500);
        }
      };

      this.retry = window.setTimeout(initialise, 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this.retry);

      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);

      if (activeReviews?.owner === this) {
        activeReviews.finish();
      }
    }
  }

  class ReviewNuggets extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();

      const frame = document.createElement('iframe');

      this.frame = frame;
      this.style.display = 'block';

      frame.title =
        `Customer review highlights for ${this.dataset.reviewProduct}`;

      frame.style.cssText =
        'display:block;width:100%;height:1px;border:0;visibility:hidden;';

      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');

      // The first load can be an empty document. Wait for our content.
      frame.addEventListener('load', () => this.mount(frame));

      frame.srcdoc = `<!doctype html>
        <html lang="en">
          <head>
            <meta charset="utf-8">
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            >
            <base target="_blank">
            <style>
              html,
              body {
                margin: 0;
                padding: 0;
                background: transparent;
              }

              body {
                font-family: Arial, sans-serif;
                color: #182249;
              }

              #plp-review-root {
                display: flow-root;
              }

              .NuggetsWidget {
                position: relative !important;
                inset: auto !important;
              }
            </style>
          </head>
          <body>
            <div id="plp-review-root"></div>
          </body>
        </html>`;

      this.replaceChildren(frame);
    }

    mount(frame) {
      if (!this.isConnected || this.frame !== frame) return;
      if (frame.dataset.plpReviewsMounted) return;

      const frameDocument = frame.contentDocument;
      const root = frameDocument?.getElementById('plp-review-root');

      if (!root) return;

      frame.dataset.plpReviewsMounted = 'true';

      const widget = frameDocument.createElement('div');

      widget.className = 'reviews-io-nuggets-widget';
      widget.setAttribute('widget-id', 'F2JSMYWKUkug59oD');
      widget.setAttribute('data-store-name', 'www-moshulu-co-uk');
      widget.setAttribute('lang', 'en');
      widget.setAttribute('data-sku', this.dataset.reviewSkus);

      root.append(widget);

      const updateHeight = () => {
        this.animation = 0;

        if (!this.isConnected || this.frame !== frame) return;

        const content = root.querySelector('.NuggetsWidget__inner');
        const hasReviews = Boolean(content?.textContent.trim());

        if (!hasReviews) {
          frame.style.height = '1px';
          frame.style.visibility = 'hidden';

          frame.setAttribute('aria-hidden', 'true');
          frame.setAttribute('tabindex', '-1');

          if (this.waitExpired) {
            this.style.display = 'none';
          }

          return;
        }

        this.style.display = 'block';

        const height =
          Math.ceil(root.getBoundingClientRect().height) + 2;

        frame.style.height = `${height}px`;
        frame.style.visibility = 'visible';

        frame.removeAttribute('aria-hidden');
        frame.removeAttribute('tabindex');
      };

      const schedule = () => {
        if (!this.isConnected || this.frame !== frame) return;

        if (!this.animation) {
          this.animation = requestAnimationFrame(updateHeight);
        }
      };

      this.resizeObserver = new ResizeObserver(schedule);
      this.resizeObserver.observe(root);

      this.mutationObserver = new MutationObserver(schedule);

      this.mutationObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });

      frameDocument.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closest('dialog')?.close();
        }
      });

      const script = frameDocument.createElement('script');

      script.src =
        'https://widget.reviews.io/modern-widgets/nuggets.js';

      script.async = true;

      script.addEventListener('error', () => {
        this.waitExpired = true;
        schedule();
      }, { once: true });

      frameDocument.body.append(script);

      this.emptyTimer = window.setTimeout(() => {
        this.waitExpired = true;
        schedule();
      }, 15000);

      schedule();
    }

    disconnectedCallback() {
      window.clearTimeout(this.emptyTimer);
      cancelAnimationFrame(this.animation);

      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.frame?.remove();

      this.frame = null;
      this.animation = 0;
      this.waitExpired = false;
    }
  }

  customElements.define(
    'moshulu-plp-review-stars',
    ReviewStars
  );

  customElements.define(
    'moshulu-plp-review-nuggets',
    ReviewNuggets
  );
})();